export default __webpack_public_path__ + "locales/pt/PeopleTranslations.json?hash=143695d8dfcb3500a450c2cc74f116a3";